/* ==========================================================================
   HALLOWEEN FREE FLAVOR — auto-add / auto-remove
   File: assets/halloween-free-gift.js
   Config: snippets/halloween-free-gift.liquid  (<script id="HalloweenGiftConfig">)

   WHAT IT DOES
   - Adds 1 line of the $0 gift product (marked with the hidden property
     _halloween_gift) when the cart value goes OVER the threshold.
   - Removes it the moment the cart value drops to the threshold or below,
     when the sale is switched off / has ended, or when the cart currency
     can't be verified. The drawer row is hidden instantly (before the
     removal request even finishes), then the drawer is refreshed.
   - Keeps it at quantity 1.
   - If the customer deletes it themselves (cart page), it is not re-added
     for the rest of their visit (until the cart is emptied).

   MULTI-CURRENCY
   Cart amounts arrive in the shopper's currency. The store-currency threshold
   is converted with Shopify's own market rate (window.Shopify.currency.rate,
   the same rate the discount uses), rounded UP to a whole unit. An optional
   per-currency override (e.g. EUR: 80) is used only if it is HIGHER, so the
   gift is never added where the discount would not make it free. The maths
   lives in window.HFG (snippets/halloween-free-gift.liquid) and is shared with
   the [threshold] amounts shown in the copy.

   ELIGIBLE SPEND
   Sum of final line prices (after other discounts — the conservative choice)
   of all cart items, excluding the free-flavor line itself. (If a collection
   handle is set in the snippet, only that collection's items count.)

   SAFETY
   - Its own requests bypass its hooks, so it never reacts to itself.
   - Loop guard: if the same change is needed 4+ times in a minute (another
     app keeps reverting it) it pauses for 5 minutes instead of fighting.
   - Honors 429 Retry-After from Shopify's cart API.
   ========================================================================== */

(function () {
  'use strict';

  var TAG = '[HalloweenGift]';
  var PROP = '_halloween_gift';
  var DECLINED_KEY = 'hfg_declined';
  var nativeFetch = window.fetch.bind(window);

  /* ---------------- config ---------------- */

  function readConfig() {
    var el = document.getElementById('HalloweenGiftConfig');
    if (!el) return null;
    try { return JSON.parse(el.textContent || '{}'); }
    catch (e) { console.error(TAG, 'Bad JSON in #HalloweenGiftConfig', e); return null; }
  }

  var cfg = readConfig();
  if (!cfg) return;

  var giftVariantId = Number(cfg.giftVariantId) || 0;
  var giftProductId = Number(cfg.giftProductId) || 0;
  var eligibleIds = Array.isArray(cfg.eligibleProductIds) ? cfg.eligibleProductIds.map(Number) : null;

  // Problems that make adding unsafe. Removal of existing gift lines still works.
  var configErrors = [];
  if (!giftVariantId) configErrors.push('giftVariantId is missing');
  if (!giftProductId) console.warn(TAG, 'gift product not found by handle (unlisted products may not be visible to Liquid) — adding by variant ID', giftVariantId);
  if (cfg.collectionHandle && !cfg.collectionFound) configErrors.push('collection "' + cfg.collectionHandle + '" not found — check hfg_collection_handle');
  if (cfg.collectionCount && cfg.collectionCount > 50) console.warn(TAG, 'Collection has', cfg.collectionCount, 'products; only the first 50 are counted as eligible.');
  if (configErrors.length) console.error(TAG, 'Gift will NOT be added:', configErrors.join('; '));

  function campaignActive() {
    if (!cfg.enabled) return false;
    var now = Date.now();
    if (cfg.startsAt) { var s = Date.parse(cfg.startsAt); if (!isNaN(s) && now < s) return false; }
    if (cfg.endsAt) { var e = Date.parse(cfg.endsAt); if (!isNaN(e) && now >= e) return false; }
    return true;
  }

  /* ---------------- currency ---------------- */

  // Threshold in the cart's currency (minor units), or null if it can't be verified.
  // Shared with the [threshold] amounts in the copy (window.HFG, defined inline
  // in snippets/halloween-free-gift.liquid), so text and behaviour always match.
  function thresholdFor(cart) {
    if (!window.HFG || typeof window.HFG.thresholdFor !== 'function') {
      console.warn(TAG, 'window.HFG helper missing — is snippets/halloween-free-gift.liquid up to date?');
      return null;
    }
    var t = window.HFG.thresholdFor(cart.currency);
    if (t === null) console.warn(TAG, 'Cannot verify exchange rate for', cart.currency, '— skipping until the page reloads in that currency.');
    return t;
  }

  /* ---------------- session flag (customer removed the gift) ---------------- */

  function isDeclined() { try { return sessionStorage.getItem(DECLINED_KEY) === '1'; } catch (e) { return false; } }
  function setDeclined(v) {
    try { v ? sessionStorage.setItem(DECLINED_KEY, '1') : sessionStorage.removeItem(DECLINED_KEY); } catch (e) {}
  }

  /* ---------------- network ---------------- */

  var pausedUntil = 0;

  function request(url, body) {
    var init = { headers: { Accept: 'application/json' } };
    if (body) {
      init.method = 'POST';
      init.headers['Content-Type'] = 'application/json';
      init.body = JSON.stringify(body);
    }
    return (function attempt(n) {
      return nativeFetch(url, init).then(function (res) {
        if (res.ok) return res.json();
        if ((res.status === 429 || res.status >= 500) && n < 2) {
          var wait = Math.max((parseFloat(res.headers.get('Retry-After')) || 0) * 1000, 800 * (n + 1));
          return new Promise(function (r) { setTimeout(r, wait); }).then(function () { return attempt(n + 1); });
        }
        if (res.status === 429) pausedUntil = Date.now() + 30000;
        return res.text().then(function (t) { throw new Error(url + ' ' + res.status + ' ' + t.slice(0, 200)); });
      });
    })(0);
  }

  function getCart() { return request('/cart.js'); }

  /* ---------------- loop guard ---------------- */

  var opLog = {};
  function guard(op) {
    var now = Date.now();
    var hits = (opLog[op] || []).filter(function (t) { return now - t < 60000; });
    hits.push(now);
    opLog[op] = hits;
    if (hits.length >= 4) {
      pausedUntil = now + 5 * 60 * 1000;
      console.error(TAG, 'LOOP GUARD: "' + op + '" needed ' + hits.length + 'x in 60s — another script keeps reverting it. Pausing for 5 minutes.');
      return false;
    }
    return true;
  }

  /* ---------------- core ---------------- */

  var lastGiftKeys = [];
  var lastGiftLines = []; // 1-based line numbers

  function isGiftLine(item) { return !!(item.properties && item.properties[PROP]); }

  function eligibleSpend(cart) {
    return cart.items.reduce(function (sum, item) {
      if (isGiftLine(item)) return sum;
      if (eligibleIds && eligibleIds.indexOf(Number(item.product_id)) === -1) return sum;
      return sum + (item.final_line_price || 0);
    }, 0);
  }

  // Returns a promise resolving to true if the cart was changed.
  function reconcile(cart) {
    if (!cart || !Array.isArray(cart.items)) return Promise.resolve(false);

    var giftLines = [];
    cart.items.forEach(function (item, i) {
      if (isGiftLine(item)) giftLines.push({ key: item.key, qty: item.quantity, line: i + 1 });
    });
    lastGiftKeys = giftLines.map(function (g) { return g.key; });
    lastGiftLines = giftLines.map(function (g) { return g.line; });

    if (!cart.item_count) setDeclined(false); // empty cart: start fresh

    if (Date.now() < pausedUntil) return Promise.resolve(false);

    var active = campaignActive();
    var threshold = active ? thresholdFor(cart) : 0;
    if (active && threshold === null) return Promise.resolve(false); // currency unverifiable: change nothing

    var spend = eligibleSpend(cart);
    /* Reset Stack bundle already gives a free flavor -> don't add a second one */
    var bundleFlavor = cart.items.some(function (it) { return it.properties && it.properties._bundle_free_flavor; });
    var wantGift = active && !configErrors.length && spend > threshold && !isDeclined() && !bundleFlavor;
    if (!wantGift && giftLines.length) hideGiftRows(); // instant: hide before the removal request

    var updates = {};
    var add = null;

    if (wantGift) {
      if (!giftLines.length) {
        add = { id: giftVariantId, quantity: 1, properties: {} };
        add.properties[PROP] = 'true';
      } else {
        giftLines.forEach(function (g, idx) {
          if (idx === 0 && g.qty !== 1) updates[g.key] = 1; // keep one, quantity 1
          if (idx > 0) updates[g.key] = 0;                  // drop duplicates
        });
      }
    } else {
      giftLines.forEach(function (g) { updates[g.key] = 0; });
    }

    var hasUpdates = Object.keys(updates).length > 0;
    if (!add && !hasUpdates) return Promise.resolve(false);

    if (add && !guard('add')) return Promise.resolve(false);
    if (hasUpdates && !guard('update')) return Promise.resolve(false);

    console.log(TAG, add ? 'adding free flavor' : 'updating free flavor', {
      currency: cart.currency, spend: spend / 100, threshold: threshold / 100, updates: updates
    });

    var p = Promise.resolve();
    if (hasUpdates) p = p.then(function () { return request('/cart/update.js', { updates: updates }); });
    if (add) p = p.then(function () { return request('/cart/add.js', { items: [add] }); });
    return p.then(function () { return true; }, function (e) { console.warn(TAG, e.message || e); return false; });
  }

  /* ---------------- instant hide ---------------- */

  // A style rule hides the Halloween gift row everywhere the moment it stops
  // qualifying — it also covers a drawer the theme re-renders a split second
  // later. Lifted after the drawer has been refreshed without the line.
  function hideGiftRows() {
    if (document.getElementById('hfg-hide')) return;
    var st = document.createElement('style');
    st.id = 'hfg-hide';
    st.textContent = '[data-hfg-gift]{display:none!important}';
    document.head.appendChild(st);
  }
  function unhideGiftRows() {
    var st = document.getElementById('hfg-hide');
    if (st) st.remove();
  }

  /* ---------------- UI refresh ---------------- */

  function onCartPage() {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    return location.pathname.replace(/\/$/, '') === cartUrl.replace(/\/$/, '');
  }

  function refreshUI() {
    if (onCartPage()) {
      var last = 0;
      try { last = Number(sessionStorage.getItem('hfg_reload')) || 0; } catch (e) {}
      if (Date.now() - last > 8000) {
        try { sessionStorage.setItem('hfg_reload', String(Date.now())); } catch (e) {}
        location.reload();
      }
      return Promise.resolve();
    }
    return nativeFetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (!data) return;
        var parser = new DOMParser();
        if (data['cart-drawer']) {
          var fresh = parser.parseFromString(data['cart-drawer'], 'text/html').querySelector('cart-drawer');
          var current = document.querySelector('cart-drawer');
          if (fresh && current) {
            var wasOpen = current.classList.contains('active');
            current.innerHTML = fresh.innerHTML;
            var overlay = current.querySelector('#CartDrawer-Overlay');
            if (overlay) overlay.addEventListener('click', function () { if (current.close) current.close(); });
            if (wasOpen) current.classList.add('active');
            current.classList.toggle('is-empty', !!fresh.classList.contains('is-empty'));
          }
        }
        if (data['cart-icon-bubble']) {
          var doc = parser.parseFromString(data['cart-icon-bubble'], 'text/html');
          var newBubble = doc.querySelector('#shopify-section-cart-icon-bubble') || doc.querySelector('.shopify-section');
          var oldBubble = document.getElementById('shopify-section-cart-icon-bubble');
          if (newBubble && oldBubble) oldBubble.innerHTML = newBubble.innerHTML;
        }
      })
      .catch(function (e) { console.warn(TAG, 'drawer refresh failed', e); });
  }

  /* ---------------- scheduling ---------------- */

  var running = false, pending = false, timer = null;

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(run, typeof delay === 'number' ? delay : 300);
  }

  var handedCart = null; // full cart from a change/update response (saves a request)

  function run() {
    if (running) { pending = true; return; }
    running = true;
    var start = handedCart ? Promise.resolve(handedCart) : getCart();
    handedCart = null;
    start
      .then(reconcile)
      .then(function (changed) {
        if (!changed) return null;
        pending = true; // re-read once: confirms the change and refreshes the gift-line snapshot
        return refreshUI();
      })
      .catch(function (e) { console.warn(TAG, e.message || e); })
      .then(function () {
        running = false;
        if (pending) { pending = false; schedule(150); }
        else unhideGiftRows(); // settled: the drawer now reflects the real cart
      });
  }

  /* ---------------- detect cart changes (fetch + XHR) ---------------- */

  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  function bodyToString(body) {
    if (!body) return '';
    if (typeof body === 'string') return body;
    try {
      if (body instanceof URLSearchParams) return body.toString();
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        var parts = [];
        body.forEach(function (v, k) { if (typeof v === 'string') parts.push(k + '=' + v); });
        return parts.join('&');
      }
    } catch (e) {}
    return '';
  }

  // Did the customer just set the free flavor's quantity to 0?
  function noteManualRemoval(url, body) {
    if (!lastGiftKeys.length || !/\/cart\/(change|update)/.test(url)) return;
    var s = decodeURIComponent(body);
    var zero = /["']?quantity["']?\s*[:=]\s*["']?0(?!\d)/;
    var hit = lastGiftKeys.some(function (k) {
      var i = s.indexOf(k);
      if (i === -1) return false;
      // update.js: {"updates":{"<key>":0}}  or  updates[<key>]=0
      if (new RegExp(k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '["\\]]?\\s*[:=]\\s*0(?!\\d)').test(s)) return true;
      // change.js: {"id":"<key>","quantity":0}
      return zero.test(s);
    }) || lastGiftLines.some(function (n) {
      return new RegExp('["\']?line["\']?\\s*[:=]\\s*["\']?' + n + '(?!\\d)').test(s) && zero.test(s);
    });
    if (hit) { setDeclined(true); console.log(TAG, 'customer removed the free flavor — will not re-add this visit'); }
  }

  function onMutation(url, body, cartFromResponse) {
    var s = bodyToString(body);
    // Note: bundle widgets add paid items AND _free_gift lines in one request,
    // so every cart mutation is checked (reconcile is a no-op when nothing changes).
    noteManualRemoval(url, s);
    if (/\/cart\/clear/.test(url)) setDeclined(false);
    if (cartFromResponse) { handedCart = cartFromResponse; schedule(0); } // change/update: act now
    else schedule(150);                                                    // add: fetch the cart first
  }

  // change.js / update.js answer with the full cart — read it from a clone.
  function cartFrom(url, res) {
    if (!/\/cart\/(change|update)/.test(url) || !res || !res.clone) return Promise.resolve(null);
    return res.clone().json().then(function (j) {
      return j && Array.isArray(j.items) && typeof j.item_count !== 'undefined' ? j : null;
    }, function () { return null; });
  }

  var wrappedFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = wrappedFetch.apply(this, arguments);
    if (CART_MUTATION.test(url)) {
      var body = init && init.body;
      p.then(function (res) {
        if (!res || !res.ok) return;
        cartFrom(url, res).then(function (cart) { onMutation(url, body, cart); });
      }, function () {});
    }
    return p;
  };

  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__hfgUrl = String(url || '');
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    var xhr = this;
    if (CART_MUTATION.test(xhr.__hfgUrl || '')) {
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          var cart = null;
          if (/\/cart\/(change|update)/.test(xhr.__hfgUrl)) {
            try { var j = JSON.parse(xhr.responseText); if (j && Array.isArray(j.items) && typeof j.item_count !== 'undefined') cart = j; } catch (e) {}
          }
          onMutation(xhr.__hfgUrl, body, cart);
        }
      });
    }
    return xhrSend.apply(this, arguments);
  };

  /* ---------------- start ---------------- */

  function start() { schedule(0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  // Back/forward cache restores an old page: re-check the cart.
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(0); });

  // Small debug helper: window.HalloweenGift.status() in the browser console.
  window.HalloweenGift = {
    status: function () {
      return getCart().then(function (cart) {
        var info = {
          active: campaignActive(), configErrors: configErrors, currency: cart.currency,
          eligibleSpend: eligibleSpend(cart) / 100,
          threshold: (thresholdFor(cart) || 0) / 100, declined: isDeclined()
        };
        console.table(info);
        return info;
      });
    },
    resetDeclined: function () { setDeclined(false); schedule(0); }
  };
})();